import { Numeric9PlusBoxIcon } from './Numeric9PlusBoxIcon';

/**
 * author: Google
 * id 7CF309F0-D751-44A3-A313-BA7F2F8865FD
 * name numeric-9-plus-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericNinePlusBoxIcon = Numeric9PlusBoxIcon;
export default NumericNinePlusBoxIcon